module.exports = __webpack_public_path__ + "static/media/hugo.9f8f7d4c.jpg";